// extracted by mini-css-extract-plugin
export default {"disabled-flags":"FlagsIcon_disabled-flags__ErDd3","hover-flags":"FlagsIcon_hover-flags__5iELk"};